export default __webpack_public_path__ + "static/media/Shadowed Valleys-22.d161e5b8.jpg";